import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard_card_icon_menu_redo",
  "use": "dashboard_card_icon_menu_redo-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dashboard_card_icon_menu_redo\"><path d=\"M14.902 13.213a6.2 6.2 0 0 0-11.908.738.884.884 0 0 1-1.726-.376 7.967 7.967 0 0 1 15.05-1.573l.933-2.276a.884.884 0 0 1 1.635.67l-1.896 4.627a.884.884 0 0 1-.477.48.967.967 0 0 1-.858-.073l-4.444-1.82 3.691-.397Z\" fill=\"#2D2C34\" stroke=\"#2D2C34\" stroke-width=\".1\" opacity=\".3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol